import { render, staticRenderFns } from "./approval-history-description.vue?vue&type=template&id=4f17a409&"
import script from "./approval-history-description.vue?vue&type=script&lang=ts&"
export * from "./approval-history-description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports